import React from "react";
import style from "./FormPost.module.css";

const UploadImage = ({ ...rest }) => {
  return (
    <React.Fragment>
      {" "}
      <label htmlFor="fileInput">
        <i className={`${style.writeIcon} fas fa-plus`}></i>
      </label>
      <input id="fileInput" type="file" style={{ display: "none" }} {...rest} />
      {/* <input id="fileInput" type="file" {...rest} /> */}
    </React.Fragment>
  );
};

export default UploadImage;
